import { useState } from "react";

const WHATSAPP_URL = "https://wa.me/573009053307";

/**
 * Botón flotante de soporte por WhatsApp (+57 300 9053307).
 * Primer clic: muestra "¿Necesitas ayuda?". Segundo clic (en el robot o en
 * la burbuja): abre el chat en otra pestaña.
 */
const WhatsAppButton = () => {
  const [open, setOpen] = useState(false);

  const openChat = () => {
    window.open(WHATSAPP_URL, "_blank", "noopener,noreferrer");
    setOpen(false);
  };

  return (
    <div
      style={{
        position: "fixed",
        right: 20,
        bottom: 20,
        zIndex: 1050,
        display: "flex",
        alignItems: "center",
        gap: 10,
      }}
    >
      {open && (
        <div style={{ position: "relative" }}>
          <button
            type="button"
            onClick={openChat}
            style={{
              background: "#fff",
              color: "#333",
              border: "none",
              borderRadius: 6,
              padding: "10px 28px 10px 16px",
              boxShadow: "0 4px 14px rgba(0,0,0,.25)",
              textAlign: "left",
              lineHeight: 1.4,
              fontSize: 14,
              cursor: "pointer",
            }}
          >
            ¿Necesitas ayuda?
            <br />
            <strong>Chatea con nosotros</strong>
          </button>
          <button
            type="button"
            aria-label="Cerrar"
            onClick={() => setOpen(false)}
            style={{
              position: "absolute",
              top: 2,
              right: 4,
              border: "none",
              background: "transparent",
              color: "#999",
              fontSize: 16,
              lineHeight: 1,
              cursor: "pointer",
            }}
          >
            ×
          </button>
        </div>
      )}
      <button
        type="button"
        aria-label={open ? "Abrir chat de WhatsApp" : "¿Necesitas ayuda?"}
        onClick={() => (open ? openChat() : setOpen(true))}
        style={{ border: "none", background: "transparent", padding: 0, cursor: "pointer" }}
      >
        <img
          src="/images/whatsapp-bot.png"
          alt="Soporte por WhatsApp"
          width={80}
          height={71}
          style={{ display: "block", filter: "drop-shadow(0 4px 8px rgba(0,0,0,.35))" }}
        />
      </button>
    </div>
  );
};

export default WhatsAppButton;
